/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DueDiligenceFee
 */
export interface DueDiligenceFee {
}

/**
 * Check if a given object implements the DueDiligenceFee interface.
 */
export function instanceOfDueDiligenceFee(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DueDiligenceFeeFromJSON(json: any): DueDiligenceFee {
    return DueDiligenceFeeFromJSONTyped(json, false);
}

export function DueDiligenceFeeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DueDiligenceFee {
    return json;
}

export function DueDiligenceFeeToJSON(value?: DueDiligenceFee | null): any {
    return value;
}

